import type { ReactNode } from "react";
import { AppShell } from "@/app/layouts/AppShell";
import { PublicAppShell } from "@/app/layouts/PublicAppShell";
import { useAuthStore } from "@/lib/auth/authStore";

interface HybridLayoutWrapperProps {
  children: ReactNode;
}

export const HybridLayoutWrapper = ({ children }: HybridLayoutWrapperProps): JSX.Element => {
  const { accessToken, user } = useAuthStore();
  const isLoggedIn = Boolean(accessToken && user);

  if (isLoggedIn) {
    return <AppShell>{children}</AppShell>;
  }

  return <PublicAppShell>{children}</PublicAppShell>;
};
